import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { DOCUMENT } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Constants } from '../constants';
import { UploadFile } from '../models';

@Component({
  selector: 'app-upload-dialog',
  templateUrl: './upload-dialog.component.html',
  styleUrls: ['./upload-dialog.component.css']
})
export class UploadDialogComponent implements OnInit {
  fileUploaded: UploadFile[] = [];
  public oldUploadedFile: File = null;
  isDisable = true;
  isFileUploaded = false;
  totalFileSize = 0;
  public multipleFiles = false;
  public fileTypeAccepted = Constants.FILE_TYPE_SUPPORTED;

  constructor(
    public dialogRef: MatDialogRef<UploadDialogComponent>,
    @Inject(DOCUMENT) private document: any,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    // if (this.oldUploadedFile[0]) {
    //   const varFileSize = this.oldUploadedFile[0].size / (1024 * 1000);
    //   this.fileUploaded.push({
    //     fileName: this.oldUploadedFile[0].name,
    //     fileSize: varFileSize,
    //     file: this.oldUploadedFile[0]
    //   });
    //   this.isFileUploaded = true;
    //   this.isDisable = false;
    // } else
    if (this.oldUploadedFile) {
      const varFileSize = this.oldUploadedFile[0].size / (1024 * 1000);
      this.fileUploaded.push({
        fileName: this.oldUploadedFile[0].name,
        fileSize: varFileSize,
        file: this.oldUploadedFile[0]
      });
      this.isFileUploaded = true;
      this.isDisable = false;
    }
  }

  deleteFile(file) {
    const index = this.fileUploaded.indexOf(file);
    this.fileUploaded.splice(index, 1);
    if (this.fileUploaded.length === 0) {
      this.isDisable = true;
    }
  }

  selectFile(event) {
    if (event.target.files.length > 0) {
      const filelist = event.target.files;
      for (const file of filelist) {
        const varFileSize = file.size / (1024 * 1000);
        this.fileUploaded.push({
          fileName: file.name,
          fileSize: varFileSize,
          file
        });
      }
      this.isFileUploaded = true;
      this.isDisable = false;
      event.target.value = null;
    }
  }

  uploadFile() {
    this.document.querySelector('#uploadBtn').click();
  }

  onUploadFiles(fileUploaded) {
    let isValidFileType = true;
    const filesToUpload = [];
    let errorCounter = 0;
    if (fileUploaded.length > 0) {
      this.totalFileSize = 0;
      for (const file of fileUploaded) {
        this.totalFileSize = this.totalFileSize + file.fileSize;
        filesToUpload.push(file.file);
      }
      if (this.fileUploaded.length > 10) {
        this.toastr.error(Constants.LABEL_ERROR, 'Reached maximum number of file limit.');
        errorCounter++;
      }
      if (this.totalFileSize > 25) {
        this.toastr.error(Constants.LABEL_ERROR, 'Maximum file Size reached.');
        errorCounter++;
      }
      for (const file of fileUploaded) {

        const validExt = this.fileTypeAccepted;
        const filePath = file.fileName;
        const getFileExt = filePath.substring(filePath.lastIndexOf('.') + 1).toLowerCase();
        const pos = validExt.indexOf(getFileExt);
        if (pos < 0) {
          isValidFileType = false;
          break;
        }
      }
      if (isValidFileType === false) {
        this.toastr.error(Constants.LABEL_ERROR, 'File Type not supported.');
        errorCounter++;
      }
      if (errorCounter === 0) {
        this.isDisable = false;
        this.dialogRef.close(filesToUpload);
      }
    }
  }
}
